import React from 'react';
import styled from 'styled-components/macro';
import { Divider } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import { stringAvatar } from '../../../../../styles/StyleConstants';
import { UploadedFile } from './UploadedFile';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.bubble.css';
import { Button } from '@material-ui/core';
import ReplyOutlinedIcon from '@mui/icons-material/ReplyOutlined';

export function ChatRecord(props) {
  const { sender, content, fileDatas, senderEmail, dateTime, contentType, setReplyMention, setReplyClick } = props;

  const handleReply = () => {
    setReplyMention(senderEmail);
    setReplyClick(true);
  };

  return (
    <Wrapper>
      <div className='record-row'>
        <Avatar className='user-icon' {...stringAvatar(sender, 30, 14)} />
        <div className='content'>
          <div className='send-info'>
            <div className='sender'>{sender}</div>
            <div className='date-time'>{new Date(dateTime).toLocaleString()}</div>
            {senderEmail &&
            <Button
              className='reply-btn'
              variant='contained'
              onClick={() => handleReply()}
            >
              <ReplyOutlinedIcon />
            </Button>
            }
          </div>
          {contentType === 'text' &&
          <ReactQuill
            className='input-field'
            theme='bubble'
            readOnly={true}
            value={content}
          />
          }
          {contentType === 'file' && fileDatas &&
          <div className='uploaded-file'>
            {fileDatas.map((item, index) => (
              <UploadedFile fileData={item} key={item.key} />
            ))}
          </div>
          }
        </div>
      </div>
      <Divider />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  margin: 5px 0;

  .record-row {
    width: 100%;
    display: flex;
    align-items: flex-start;

    .content {
      width: 100%;
      margin-left: 5px;

      .send-info {
        display: flex;
        align-items: center;
        height: 30px;
        position: relative;

        .sender {
          margin-right: 5px;
          font-weight: 700;
        }

        .date-time {
          margin-left: 10px;
          font-size: 12px;
        }

        .reply-btn {
          color: ${p => p.theme.buttonFont};
          background: ${p => p.theme.buttonColor};
          padding: 0;
          min-width: unset;
          position: absolute;
          right: 10px;
          opacity: 70%;
        }
      }

      .input-field {
        pointer-events: none;
        width: 100%;
        margin: -10px -15px -5px;
      }

      .uploaded-file {
        display: flex;
      }
    }
  }
`;
